// @flow
// Copied and adapted from packages/author-ui/src/context/AssignmentContextProvider.tsx

import { useState } from "react";

import { SchemaContext } from "./SchemaContext";
import SchemaDataService from "../axios/services/schema.service";
import { Schema } from "../types/Schema";

interface Props {
  children: any;
}
export const SchemaContextProvider = (props: Props): any => {
  const [schemas, setSchemas] = useState<Array<Schema>>([]);
  const [schemaId, setSchemaId] = useState<number>(-1);

  const updateSchemas = () => {
    const all = SchemaDataService.getAll();
    return all
      .then((response: any) => {
        if (response.status !== 200) return;
        setSchemas(response.data.data);
      })
      .catch((e: any) => {
        console.log(e);
      });
  };

  /**
   * This code is copied from AssignmentContextProvider.createAssignment
   */
  const createSchema = async (data: Object): Promise<number> => {
    return new Promise<number>((resolve, reject) => {
      SchemaDataService.create(data).then((response: any) => {
        console.log(response);
        if (response.data.success) {
          updateSchemas();
          setSchemaId(response.data.data.id); // TODO
          return resolve(response.data.data.id);
        } else {
          /** TODO SHOULD HANDLE UNSUCCESSFULL FETCHING EXERCISES HERE. */
          reject(-1);
        }
      });
    });
  };

  /**
   * This code is copied from AssignmentContextProvider.updateAssignment
   */
  const updateSchema = (id: any, schema: any) => {
    SchemaDataService.update(id, schema)
      .then((response: any) => {
        console.log(response);
        if (response.data.success) {
          updateSchemas();
        } else {
          /** TODO SHOULD HANDLE UNSUCCESSFULL DELETING ASSIGNMENT HERE. */
        }
      })
      .catch((e: any) => {
        /** TODO SHOULD HANDLE ERROR DELETING ASSIGNMENTS. */
        console.warn(e);
      });
  };

  /**
   * This code is copied from AssignmentContextProvider.deleteAssignment
   */
  const deleteSchema = (id: any) => {
    SchemaDataService.delete(id)
      .then((response: any) => {
        console.log(response);
        if (response.data.success) {
          updateSchemas();
        } else {
          /** TODO SHOULD HANDLE UNSUCCESSFULL DELETING ASSIGNMENT HERE. */
        }
      })
      .catch((e: any) => {
        /** TODO SHOULD HANDLE ERROR DELETING ASSIGNMENTS. */
        console.warn(e);
      });
  };

  return (
    <SchemaContext.Provider
      value={{
        schemas: schemas,
        schemaId: schemaId,
        updateSchemas: updateSchemas,
        createSchema: createSchema,
        updateSchema: updateSchema,
        deleteSchema: deleteSchema,
      }}
    >
      {props.children}
    </SchemaContext.Provider>
  );
};
